<template>
  <v-card outlined>
    <div>
      <v-row justify="center" align="center" class="pt-4">
        <CardResume
          color="lightBlue"
          avatarColor="blue"
          icon="mdi-phone mdi-48px"
          progressValue="100"
          title="Total de Ligações"
          :info="atendidas + naoAtendidas"
        />
      </v-row>
      <v-row justify="space-around" align="center" class="my-4">
        <CardResume
          color="lightGreen"
          avatarColor="green"
          icon="mdi-check-decagram mdi-48px"
          :progressValue="getProgressValueNumber('atendidas')"
          title="Atendidas"
          :info="atendidas"
        />
        <CardResume
          color="lightRed"
          avatarColor="red"
          icon="mdi-close-octagon mdi-48px"
          :info="naoAtendidas"
          :progressValue="getProgressValueNumber('naoAtendidas')"
          title="Não Atendidas"
        />
      </v-row>
    </div>
  </v-card>
</template>

<script>
import CardResume from '../../../../components/CardResume'
export default {
  name: 'CardsResumoOperador',
  props: {
    atendidas: Number,
    naoAtendidas: Number,
  },
  components: { CardResume },

  methods: {
    getProgressValueNumber(tipoLigacao) {
      if (this.atendidas + this.naoAtendidas === 0) {
        return 100
      } else if (tipoLigacao === 'atendida') {
        return (this.atendidas / (this.atendidas + this.naoAtendidas)) * 100
      } else {
        return (this.naoAtendidas / (this.atendidas + this.naoAtendidas)) * 100
      }
    },
  },
}
</script>
